import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {Modal,Button} from '@material-ui/core';

import Alerta from '../../../../../../snackbars/.mixins';
import Section from '../childrens/Section/.mixins/Section'

import ModalCss from './Modal-css';
const styles = ModalCss();

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

class SimpleModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      id: null
    };
    this.inputRef = React.createRef();
    this.child = React.createRef();
    this.childSection = React.createRef();
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen(id){
    this.setState({ open: true });
    this.setState({ id: id });
  };

  handleClose(){
    setTimeout(() => {
      this.setState({ open: false });
    }, 200);
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
        >
          <div style={getModalStyle()} className={classes.paper}>
            <Section {...this} ref={this.childSection}/>
            <br/>
            <div align="right">
                <Button className={classes.buttonCancelar} onClick={this.handleClose}>
                    Não
                </Button>
                <Button variant="contained" className={classes.buttonConfirmar} onClick={(e)=>{this.props.pai.cancelarPedido(this)}}>
                    Sim
                </Button>
            </div>
            <SimpleModalWrapped />
          </div>
        </Modal>
        <Alerta ref={this.child}/>
      </div>
    );
  }
}

SimpleModal.propTypes = {
  classes: PropTypes.object.isRequired,
};


const SimpleModalWrapped = withStyles(styles)(SimpleModal);

export default SimpleModalWrapped;